import React, { useEffect, useState } from 'react';
import classnames from 'classnames/bind';
import { Fade } from 'react-awesome-reveal';
import { PrelandCardSelector } from '../PrelandCardSelector';
import { Button } from '../../Button';
import { GameProgressBar } from '../GameProgressBar';
import { Indicator } from '../Indicator';
import CustomModal from '../../Modal';
import decorImageSrc from '../../../assets/images/prelander/decor.png';
import silverWinnerImageSrc from '../../../assets/images/prelander/silver-winner.png';
import captainImageSrc from '../../../assets/images/prelander/captain.png';
import shooterImageSrc from '../../../assets/images/prelander/shooter.png';
import defenderImageSrc from '../../../assets/images/prelander/defender.png';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import styles from './SilverStage.css';

const cx = classnames.bind(styles);

const ROLE_MODAL = 'roleModal';

const CAPTAIN = 'captain';
const DEFENDER = 'defender';
const SHOOTER = 'shooter';

const ROLES = [CAPTAIN, SHOOTER, DEFENDER];

const ROLE_CARDS_INFORMATION_LIST = [
    {
        id: CAPTAIN,
        name: 'Captain',
        description: 'in-game leader'
    },
    {
        id: SHOOTER,
        name: 'Shooter',
        description: 'Captain'
    },
    {
        id: DEFENDER,
        name: 'Defender',
        description: 'Support'
    }
];

const INFORMATION_ROLES_FOR_MODAL = {
    captain: {
        imageUrl: captainImageSrc,
        description: 'Now choose the captain'
    },
    shooter: {
        imageUrl: shooterImageSrc,
        description: 'Now choose the shooter'
    },
    defender: {
        imageUrl: defenderImageSrc,
        description: 'Now choose the defender'
    }
};

function SilverStage({initialCards, finishStage, selectRoleCard, teamPowerScore}) {
    const [isFinish, setIsFinish] = useState(false);
    const [roleIndex, setRoleIndex] = useState(0);
    const role = ROLES[roleIndex];
    const [modal, setModal] = useState({type: ROLE_MODAL, data: INFORMATION_ROLES_FOR_MODAL[role]});
    const [cards, setCards] = useState(initialCards);
    const [isAnimateModalContent, setIsAnimateModalContent] = useState(false);

    useEffect(() => {
        logEvent(EVENT_TYPES.CAPTAIN_SCREEN_VISITED);
    }, []);

    useEffect(() => {
        if (!isFinish) {

            if (role === CAPTAIN && modal.type === ROLE_MODAL) {
                setIsAnimateModalContent(true);

                setTimeout(() => {
                    setIsAnimateModalContent(false);
                }, 2500);

                setTimeout(() => {
                    setModal({type: '', data: ''});
                }, 3000);
            }
    
            if (role === SHOOTER) {
                setModal({type: ROLE_MODAL, data: INFORMATION_ROLES_FOR_MODAL[SHOOTER]});
                setTimeout(() => {
                    setIsAnimateModalContent(true);
                }, 0);

                setTimeout(() => {
                    setIsAnimateModalContent(false);
                }, 2500);
    
                setTimeout(() => {
                    setModal({type: '', data: ''});
                }, 3000);
            }
    
            if (role === DEFENDER) {
                setModal({type: ROLE_MODAL, data: INFORMATION_ROLES_FOR_MODAL[DEFENDER]});
                setTimeout(() => {
                    setIsAnimateModalContent(true);
                }, 0);

                setTimeout(() => {
                    setIsAnimateModalContent(false);
                }, 2500);
    
                setTimeout(() => {
                    setModal({type: '', data: ''});
                }, 3000);
            }
        }
    }, [role]);

    const handleFinish = () => {
        setModal({type: '', data: {}});
        setIsFinish(true);
    };

    const onSelectCard = ({card, isSelected}) => {
        if (isSelected) {
            selectRoleCard(role, card);

            if (roleIndex + 1 >= ROLES.length) {
                return handleFinish();
            } else {
                setRoleIndex(roleIndex + 1);
            }
        };
    
        setCards(prevState => {
            const [currentCard, nextCard, ...otherCards] = prevState;

            return [
                {...nextCard, isActive: true},
                ...otherCards,
                ...(!isSelected ? [{...currentCard, id: Math.random(), isActive: false}] : [])
            ]
        });
    };

    const renderContent = () => {
        if (isFinish) {
            return (
                <Fade
                    duration={500}
                    className={styles.container}
                    triggerOnce
                >
                    <div className={cx('content', 'finish')}>
                        <GameProgressBar
                            progressList={[100, 100, 0]}
                        />
                        <div className={styles.wrapper}>
                            <img
                                src={`${silverWinnerImageSrc}?v=3`}
                                alt='silver'
                                className={styles.imageWinner}
                            />
                        </div>
                        <div className={styles.footerFinish}>
                            <Button
                                label='Continue'
                                onClick={finishStage}
                                className={styles.fullButton}
                            />
                        </div>
                    </div>
                </Fade>
            );
        }

        return (
            <Fade
                duration={500}
                className={styles.container}
                triggerOnce
            >
                <div className={styles.content}>
                    <GameProgressBar
                        progressList={[100, (roleIndex / ROLES.length * 100) || 5, 0]}
                    />
                    <div className={styles.rolesListWrapper}>
                        <div className={styles.rolesList}>
                            {role === CAPTAIN && (
                                <>
                                    <div style={{width: 96, height: '100%', flexShrink: 0}} />
                                    <div style={{width: 107, height: '100%', flexShrink: 0}} />
                                </>
                            )}
                            {ROLE_CARDS_INFORMATION_LIST.map(item => (
                                <div
                                    className={cx('rolesListItem', {active: role === item.id})}
                                    key={item.id}
                                    id={item.id}
                                >
                                    <span className={styles.rolesListItemDescription}>{item.description}</span>
                                    <span className={styles.rolesListItemName}>{item.name}</span>
                                </div>
                            ))}
                            {role === DEFENDER && (
                                <>
                                    <div style={{width: 88, height: '100%', flexShrink: 0}} />
                                    <div style={{width: 96, height: '100%', flexShrink: 0}} />
                                </>
                            )}
                        </div>
                    </div>
                    <PrelandCardSelector
                        cards={cards}
                        onSelectCard={onSelectCard}
                    />
                    <div className={styles.teamPower}>
                        <p className={styles.teamPowerTitle}>Your team power</p>
                        <Indicator
                            value={teamPowerScore}
                            incValue={cards[0]?.[`${role}RoleScore`] || 0}
                            height={8}
                        />
                    </div>
                </div>
            </Fade>
        );
    };

    return (
        <>
            {renderContent()}
            <CustomModal
                isOpen={modal.type === ROLE_MODAL}
                onCloseModal={() => {}}
                overlayClassName={styles.overlay}
                className={styles.modal}
                key={role}
            >
                <img
                    src={modal.data?.imageUrl}
                    alt='role'
                    className={cx('modalImage', {withAnimation: isAnimateModalContent})}
                />
                <div className={cx('modalWrapper', {withAnimation: isAnimateModalContent})}>
                    <img
                        src={decorImageSrc}
                        alt='decor'
                        className={cx('imageDecor', 'top')}
                    />
                    <span className={cx('modalText', 'modalTextUppercase')}>{modal.data?.description}</span>
                    <img
                        src={decorImageSrc}
                        alt='decor'
                        className={cx('imageDecor', 'bottom')}
                    />
                </div>
                <div className={styles.modalImage} />
            </CustomModal>
        </>
    )
}

export {
    SilverStage
}
